import { Injectable } from '@angular/core';
import randomWords from 'random-words';

export interface RandomWordsOptions {
  readonly exactly?: number;
  readonly maxLength?: number;
  readonly seed?: string;
}

@Injectable({
  providedIn: 'root',
})
export class RandomWordsService {
  generateRandomWords(options: RandomWordsOptions): readonly string[] {
    return randomWords({
      ...options,
    });
  }
}
